import type { FC } from "react"

import { useQuery } from "@apollo/client"

import styles from "./CompaniesPage.module.scss"
import CompanyListTable from "./CompanyListTable"

import { graphql } from "@/souhl_admin/gql/__generated__/gql"

const GetCompanies = graphql(/* GraphQL */ `
	query GetCompanies {
		companies {
			companies {
				...CompanyListTable
			}
		}
	}
`)

const GetFeatureFlagsForList = graphql(/* GraphQL */ `
	query GetFeatureFlagsForList($param: FeatureFlagsParam!) {
		featureFlags(param: $param) {
			featureFlags {
				...CompanyListTableFeatureFlag
			}
		}
	}
`)

const CompaniesPage: FC = () => {
	const { data, loading } = useQuery(GetCompanies, {
		fetchPolicy: "no-cache",
	})

	const { data: flagsData } = useQuery(GetFeatureFlagsForList, {
		variables: { param: {} },
		fetchPolicy: "cache-first",
	})

	if (loading && !data) {
		return (
			<div className={styles.loadingContainer}>
				<div className={styles.loading}>読み込み中...</div>
			</div>
		)
	}

	const companies = data?.companies.companies ?? []
	const featureFlags = flagsData?.featureFlags.featureFlags ?? []

	return (
		<div className={styles.container}>
			<CompanyListTable companies={companies} featureFlags={featureFlags} />
		</div>
	)
}

export default CompaniesPage
